export const solicitationKind: Record<string, string> = {
  emergency: 'Emergência',
  corrective: 'Corretiva',
  piece_buy: 'Comprar peça',
  factory_warranty: 'Garantia de fábrica',
  piece_warranty: 'Garantia da peça',
  urgency: 'Urgência',
  preventive: 'Preventiva',
}
